module.exports = __webpack_public_path__ + "static/media/Variable Rewards - hush-naidoo-jade-photography-ax_jJpHdYjI-unsplash.ed5d3d47.jpg";